import React, { useState, useEffect } from 'react';
import TextInput from '../../layout/forms/TextInput';

const ObjectUid = ({ state, setState }) => {
    const onChange = (event) => {
        setState({
            ...state,
            objectUid: event.target.value
        })
    }
    return (
        <TextInput
            label="Object uid"
            onChange={onChange}
            value={state.objectUid}
        />
    )
}
export default ObjectUid